export default __webpack_public_path__ + "static/flavor-citrus-bc8472bb314e9774d5f7db11be5a4b47.svg";